import type {HostMap} from '../../../types'

export const UNSTABLE = {} as const satisfies HostMap
